import React, { Component } from 'react';
import Topbar from '../../components/common/Topbar';
import Footer from '../../components/common/Footer';
import AdditionalCharge from '../../components/master/AdditionalCharge';

class AdditionalChargePage extends Component {
    render() {
        return (
            <>
                <div id="content-wrapper" className="d-flex flex-column master-page-layout">
                    <div id="content">

                        <Topbar />

                        <div className="container-fluid">

                            <AdditionalCharge />

                        </div>

                    </div>

                    <Footer />

                </div>
            </>
        );
    }
}

export default AdditionalChargePage;